export default __webpack_public_path__ + "static/media/knot-flourish.c17aea77.png";